module.exports = __webpack_public_path__ + "img/blog6-logo-8.820306bc.webp";